"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ReceiveAddressComponent = _interopRequireDefault(require("./ReceiveAddressComponent"));
var _depositActions = require("../../../redux/actions/depositActions");
var _snackbarActions = require("../../../redux/actions/snackbarActions");
var _config = _interopRequireDefault(require("../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    deposit: state.deposit,
    WalletsDisabledMessage: _config["default"].global.WalletsDisabledMessage
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch((0, _depositActions.fetchAllProductDepositTemplates)(productId));
    },
    fetchAccountProviderDepositInfo: function fetchAccountProviderDepositInfo(productId, accountProviderId) {
      // Clear any depositInfo from the previously-selected provider so the old
      // QR / address row don't linger during the new fetch (and stay if the
      // new provider returns an empty list).
      dispatch({
        type: _depositActions.RESET_DEPOSIT_INFO
      });
      return dispatch((0, _depositActions.getDepositInfo)(productId, undefined, accountProviderId, false));
    },
    generateNewDepositAddress: function generateNewDepositAddress(productId, accountProviderId) {
      return dispatch((0, _depositActions.getDepositInfo)(productId, undefined, accountProviderId, true));
    },
    showSnack: function showSnack(text) {
      return dispatch((0, _snackbarActions.showSnack)(text));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ReceiveAddressComponent["default"]);